import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AdminLayout } from '../components';
import { selectIsAdmin } from '../../auth/ducks';
import { selectQuestionCount, fetchQuestionCountActions } from '../../help-management/ducks';
import { bindActionCreators } from 'redux';
import { helpStatus } from '../../../common/enums';


const mapStateToProps = state => ({
  isAdmin: selectIsAdmin(state),
  questionCount: selectQuestionCount(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchQuestionCount: fetchQuestionCountActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AdminWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidMount(){
    this.props.actions.fetchQuestionCount({
      id_status: helpStatus.NEZODPOVEDANA
    })
  }

  onChange(){
    this.props.actions.fetchQuestionCount({
      id_status: helpStatus.NEZODPOVEDANA
    })
  }

  render() {
    const { children, isAdmin, questionCount } = this.props;

    return <AdminLayout onChange={this.onChange.bind(this)} questionCount={questionCount || 0} isAdmin={isAdmin}>{children}</AdminLayout>;
  }
}



// WEBPACK FOOTER //
// ./src/features/admin/containers/AdminWrapper.js